import React, { useEffect, useState } from 'react';
import Icon from './Icon';

// Floating jump-to-top button. Appears once the page is scrolled down a bit
// (most useful on long pages like Attendees on mobile). The header/hamburger
// is sticky, so navigation is always reachable — this is purely scroll-to-top.
export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!show) return null;

  const toTop = () => {
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  };

  return (
    <button type="button" className="portal-to-top" onClick={toTop} aria-label="Back to top">
      <Icon name="arrow-up" size={22} />
    </button>
  );
}
